import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "gfu-project-summary-action",
  "data-qa": "project-summary-follow"
}
const _hoisted_2 = {
  key: 0,
  class: "gfu-media gfu-media--middle"
}
const _hoisted_3 = { class: "gfu-media__body" }
const _hoisted_4 = {
  key: 0,
  class: "gfu-bt gfu-bt--b2 _ma-0"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "gfu-bt gfu-bt--b2 _ma-0" }
const _hoisted_7 = ["innerHTML"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_follow_project_button = _resolveComponent("follow-project-button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($options.userIsFollowingProject)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_base_icon, {
            name: "heart",
            class: _normalizeClass(['gfu-project-summary-action__side', $options.unfollowContentColor])
          }, null, 8 /* PROPS */, ["class"]),
          _createElementVNode("div", _hoisted_3, [
            ($options.followersCount > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("span", { innerHTML: $options.youAndOthersAreFollowingText }, null, 8 /* PROPS */, _hoisted_5),
                  _createElementVNode("a", {
                    href: "#",
                    class: _normalizeClass(['gfu-link', $options.unfollowContentColor]),
                    onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => ($options.onUnfollow && $options.onUnfollow(...args)), ["prevent"])),
                    "data-qa": "unsubscribe-link"
                  }, _toDisplayString(_ctx.Resources.ProjectHome.UnfollowProjectButton), 3 /* TEXT, CLASS */)
                ]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.Resources.ProjectHome.ProjectSummaryYouAreFollowingText), 1 /* TEXT */),
                  _createElementVNode("a", {
                    href: "#",
                    class: _normalizeClass(['gfu-link', $options.unfollowContentColor]),
                    onClick: _cache[1] || (_cache[1] = _withModifiers((...args) => ($options.onUnfollow && $options.onUnfollow(...args)), ["prevent"])),
                    "data-qa": "unsubscribe-link"
                  }, _toDisplayString(_ctx.Resources.ProjectHome.UnfollowProjectButton), 3 /* TEXT, CLASS */)
                ], 64 /* STABLE_FRAGMENT */))
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "gfu-project-summary-action__side" }, null, -1 /* CACHED */))
        ]))
      : (_ctx.projectContext.projectID)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_component_follow_project_button, {
              "is-authenticated": _ctx.isAuthenticated,
              "project-id": _ctx.projectContext.projectID,
              "project-name": _ctx.projectContext.project.name,
              theme: $props.buttonTheme,
              section: $data.section,
              class: "gfu-1of1"
            }, null, 8 /* PROPS */, ["is-authenticated", "project-id", "project-name", "theme", "section"]),
            ($options.isButtonFollowerCountVisible)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "_tac _mt-1",
                  innerHTML: $options.othersAreFollowingText
                }, null, 8 /* PROPS */, _hoisted_7))
              : _createCommentVNode("v-if", true)
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("v-if", true)
  ]))
}